/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Board_FiltersInputs */

const en_directory_home_board_filters = /** @type {(inputs: Directory_Home_Board_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore filters`)
};

const zh_directory_home_board_filters = /** @type {(inputs: Directory_Home_Board_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`筛选`)
};

/**
* | output |
* | --- |
* | "Explore filters" |
*
* @param {Directory_Home_Board_FiltersInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_board_filters = /** @type {((inputs?: Directory_Home_Board_FiltersInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Board_FiltersInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_board_filters(inputs)
	return zh_directory_home_board_filters(inputs)
});
export { directory_home_board_filters as "directory.home.board.filters" }